// Traduções desta tela — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'grid.dataGrid.editCellSelection': 'Editar seleção da célula',
    'grid.dataGrid.nothingFound': 'Nada encontrado',
    'grid.dataGrid.searchPlaceholder': 'Buscar…',
    'grid.dataGrid.noOptionsFound': 'Nenhuma opção encontrada',
    'grid.dataGrid.empty': 'Nada por aqui.',
  },
  en: {
    'grid.dataGrid.editCellSelection': 'Edit cell selection',
    'grid.dataGrid.nothingFound': 'Nothing found',
    'grid.dataGrid.searchPlaceholder': 'Search…',
    'grid.dataGrid.noOptionsFound': 'No options found',
    'grid.dataGrid.empty': 'Nothing here.',
  },
  es: {
    'grid.dataGrid.editCellSelection': 'Editar selección de la celda',
    'grid.dataGrid.nothingFound': 'Nada encontrado',
    'grid.dataGrid.searchPlaceholder': 'Buscar…',
    'grid.dataGrid.noOptionsFound': 'Ninguna opción encontrada',
    'grid.dataGrid.empty': 'Nada por aquí.',
  },
}
